import styled from 'styled-components';

const PageSectionHeader = styled.div`
  margin: 0 0 2em 0;
`;

export default PageSectionHeader;



// WEBPACK FOOTER //
// ./client/components/shared/PageSectionHeader/index.js